import type { ReactNode } from "react";

function cleanBitrixMarkup(value: string): string {
  return value
    .replace(/\[USER=[^\]]*\]([\s\S]*?)\[\/USER\]/gi, "$1")
    .replace(/(^|\n)\s*>\s*(?=(?:Переданы дополнительные данные|Ссылка на исходный пост|Название вакансии))/giu, "$1");
}

function safeHref(value: string | null): string | undefined {
  if (!value) return undefined;
  try {
    const url = new URL(value, window.location.origin);
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : undefined;
  } catch {
    return undefined;
  }
}

function renderNode(node: Node, key: string): ReactNode {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent;
  if (node.nodeType !== Node.ELEMENT_NODE) return null;
  const element = node as HTMLElement;
  const children = Array.from(element.childNodes).map((child, index) => renderNode(child, `${key}-${index}`));
  switch (element.tagName.toLowerCase()) {
    case "br": return <br key={key} />;
    case "b":
    case "strong": return <strong key={key}>{children}</strong>;
    case "i":
    case "em": return <em key={key}>{children}</em>;
    case "a": {
      const href = safeHref(element.getAttribute("href"));
      return href ? <a key={key} href={href} target="_blank" rel="noreferrer">{children}</a> : <span key={key}>{children}</span>;
    }
    default: return <span key={key}>{children}</span>;
  }
}

export function MessageContent({ text }: { text: string }): ReactNode {
  const cleaned = cleanBitrixMarkup(text);
  if (typeof DOMParser === "undefined") return cleaned;
  const root = new DOMParser().parseFromString(`<div>${cleaned}</div>`, "text/html").body.firstElementChild;
  if (!root) return cleaned;
  return Array.from(root.childNodes).map((node, index) => renderNode(node, `message-${index}`));
}
